import './styles/AgentAuthYellowPasswordStyle.css';
import React, { useState } from 'react';
import {
  BaseInput,
  NavigationButton,
  Keyboard,
  TopNav,
  TopNavToastMessage,
  ToastType,
} from '../common';
import { languageMap } from '../../maps/languageMap';
import { useActions, useTypedSelector } from '../../hooks';
import { APIResponseStatusType, navigationPages } from '../../models/types';
import { useHistory } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import {
  EmployeeLoginRequestPOST,
  EmployeeLoginResponsePOST,
  SessionRequestPOST,
  SessionResponsePOST,
} from '../../models/cruds';
import { apiErrorHandler, apiPOST } from '../../restApi';

const VALIDATE_YELLOW_PASSWORD_ERROR_FEEDBACK_MESSAGE = 'Error en la consulta';
const VALIDATE_YELLOW_PASSWORD_FEEDBACK_MESSAGE =
  'Por favor ingresa una contraseña.';

const AgentAuthYellowPassword: React.FC = () => {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [password, setPassword] = useState('');
  const [variableInError, setVariableInError] = useState('');
  const language = useTypedSelector(({ session }) => {
    return session.language;
  });
  const employeeNumber = useTypedSelector(({ locker }) => {
    return locker.employeeNumber;
  });
  const token = useTypedSelector(({ session }) => {
    return session.dhlApiToken;
  });
  const lockerInstallation = useTypedSelector(({ kioskData }) => {
    return kioskData.installation;
  });
  const { sessionUpdateAgentToken } = useActions();
  const openEmployeeSession = async (agentToken: string): Promise<boolean> => {
    let request = new SessionRequestPOST();
    let response: SessionResponsePOST = await apiPOST(
      request.buildURL(),
      request.generateContent(lockerInstallation.id.toString()),
      request.generateConfig(agentToken)
    );
    let errorMsg = '';
    try {
      if (response.status === APIResponseStatusType.SUCCESS) {
        if (response.data.session) {
          return true;
        } else {
          //TODO check for unauth and refresh token
          errorMsg = 'Unauthorized';
        }
      } else {
        errorMsg = apiErrorHandler(response);
      }
    } catch (err: any) {
      errorMsg = err.toString();
    }
    console.log(errorMsg);
    return false;
  };
  const requestEmployeeValidation = async (): Promise<boolean> => {
    if (password === '') {
      setFeedbackMessage(VALIDATE_YELLOW_PASSWORD_FEEDBACK_MESSAGE);
      return false;
    }
    setLoading(true);
    let request = new EmployeeLoginRequestPOST();
    let response: EmployeeLoginResponsePOST = await apiPOST(
      request.buildURL(),
      request.generateContent(employeeNumber, password),
      request.generateConfig(token)
    );
    let errorMsg = '';
    try {
      if (response.status === APIResponseStatusType.SUCCESS) {
        if (
          response.data.token &&
          (await openEmployeeSession(response.data.token))
        ) {
          sessionUpdateAgentToken(response.data.token);
          history.replace(`/${navigationPages.AGENT_PROCESS_SELECTION}`);
        } else {
          errorMsg = 'Unauthorized';
        }
      } else {
        errorMsg = apiErrorHandler(response);
      }
    } catch (err: any) {
      errorMsg = err.toString();
    }
    console.log(errorMsg);
    setLoading(false);
    setFeedbackMessage(VALIDATE_YELLOW_PASSWORD_ERROR_FEEDBACK_MESSAGE);
    return false;
  };
  const handleKeypress = (e: any) => {
    //it triggers by pressing the enter key
    if (e.key === 'Enter') {
      requestEmployeeValidation();
    }
  };
  const handleKeyboard = (option: string) => {
    setFeedbackMessage('');
    //it triggers by pressing the enter key
    if (option === 'go') {
      requestEmployeeValidation();
      return;
    }
    if (option === 'back') {
      setPassword(password.slice(0, -1));
      return;
    }
    setPassword(password + option);
  };
  const renderKeyboard = () => {
    if (loading) {
      return (
        <div className="client-retrieval-scan-numpad-container">
          <div className="spinner-container">
            <Spinner className="spinner" animation="grow" variant="danger" />
          </div>
        </div>
      );
    }
    return (
      <Keyboard
        keyBoardType="password"
        onClickButton={(option) => {
          handleKeyboard(option);
        }}
      />
    );
  };
  const renderContent = () => {
    return (
      <div className="yellow-password-container">
        <div className="yellow-password-tag-container">
          <BaseInput
            val={password}
            inputLabel=""
            inputPlaceholder="**********"
            inError={variableInError === 'password'}
            onTextChange={(newVal: string) => {
              setVariableInError('');
              setFeedbackMessage('');
              setPassword(newVal);
            }}
            disabled={loading}
            type="password"
            handleKeypress={handleKeypress}
            extraClassContainer="no-padding-right full-width stretched"
            extraClass="placeholder-left"
          />
        </div>
        <div className="yellow-password-keyboard-container">
          {renderKeyboard()}
        </div>
      </div>
    );
  };
  return (
    <div id="clientRetrievalIssues" className="main-container">
      <TopNav dataCyPrefix="scan-awb" />
      <div className="content-container">
        <div className="main-content-container fullpage">
          <TopNavToastMessage
            toastText={feedbackMessage}
            toastType={ToastType.ERROR}
            resetMessage={() => setFeedbackMessage('')}
          />
          <div className="title-content-container">
            <p className="header nopadding nomargin">
              {languageMap.agent_auth_yellow_password.title[language]}
            </p>
          </div>
          <div className="data-content-container">{renderContent()}</div>
          <div className="footer-container">
            <div className="footer-button-container">
              <NavigationButton
                buttonContent={
                  languageMap.agent_auth_yellow_password.back_button[language]
                }
                buttonClass="navigation-button cancel-button"
                onClickButton={() => {
                  history.replace(
                    `/${navigationPages.AGENT_AUTH_EMPLOYEE_NUMBER}`
                  );
                }}
              />
            </div>
            <div className="footer-button-container">
              <NavigationButton
                buttonContent={
                  languageMap.agent_auth_yellow_password.continue_button[
                    language
                  ]
                }
                buttonClass="navigation-button confirm-button"
                onClickButton={() => {
                  requestEmployeeValidation();
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { AgentAuthYellowPassword };
